var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQoEMeter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_210_7432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.875C1.5 15.5454 1.76189 14.2287 2.27072 13.0003C2.77955 11.7719 3.52535 10.6557 4.46555 9.71554C5.40574 8.77535 6.52191 8.02955 7.75034 7.52072C8.97876 7.01189 10.2954 6.75 11.625 6.75C12.9546 6.75 14.2713 7.01189 15.4997 7.52072C16.7281 8.02955 17.8443 8.77536 18.7845 9.71555C19.7247 10.6557 20.4705 11.7719 20.9793 13.0003C21.4881 14.2288 21.75 15.5454 21.75 16.875",
    stroke: "#CCCCCC",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.875C1.5 15.5454 1.76189 14.2288 2.27072 13.0003C2.77955 11.7719 3.52535 10.6557 4.46554 9.71554C5.40574 8.77535 6.52191 8.02955 7.75033 7.52072C8.97875 7.01189 10.2954 6.75 11.625 6.75C12.9546 6.75 14.2712 7.01189 15.4997 7.52072C16.7281 8.02955 17.8443 8.77535 18.7845 9.71554C19.7247 10.6557 20.4705 11.7719 20.9793 13.0003C21.4881 14.2288 21.75 15.5454 21.75 16.875",
    stroke: "url(#paint0_linear_210_7432)",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15.75,
    r: 1.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.628 15.7537C11.5063 15.9212 11.5434 16.1557 11.7109 16.2775C11.8785 16.3992 12.113 16.3621 12.2347 16.1946L11.9314 15.9741L11.628 15.7537ZM11.9314 15.9741L12.2347 16.1946L17.3033 9.22046L17 9L16.6967 8.77953L11.628 15.7537L11.9314 15.9741Z",
    fill: "#545454"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_210_7432",
    x1: 1.5,
    y1: 16.5,
    x2: 22,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0B1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#500D76"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_210_7432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQoEMeter);
export default __webpack_public_path__ + "static/media/QoE_Meter.5b1a0382d0a0f2f3551075b93bb2b13e.svg";
export { ForwardRef as ReactComponent };